import { Checkbox, CheckboxProps } from '@mui/material';
import React, { FC } from 'react';

export type CheckBoxProps = CheckboxProps;

export const CheckBox: FC<CheckBoxProps> = (props: CheckBoxProps) => {
  const { ...other } = props;
  return <Checkbox {...other} disableRipple={true} />;
};
